<template>
  <div class="player-info">
    <!-- 创建态（无 playerId）才展示顶部球队/赛事信息；查看态隐藏 -->
    <div class="title-info" v-if="!isEditMode && !playerId">
      <!-- 第一块：球队 logo + 球队名称 + 邀你进行报名资料收集，背景色使用 --bg3 -->
      <div class="top-banner">
        <div class="team-left">
          <div class="team-logo">
            <img :src="imageView(team.badge || match.icon)" alt="" />
          </div>
          <div class="team-text">
            <div class="team-name">{{ team.name || '-' }} <span>邀你进行报名资料收集</span></div>
          </div>
        </div>
      </div>
      <!-- 第二块：赛事信息 -->
      <div class="event-info">
        <div class="event-row event-match">
          <span class="label">赛事：</span>
          <img :src="imageView(match.icon)" alt="" class="event-logo" />
          <span class="value">{{ match.chineseName || match.unionMatchName || '-' }}</span>
        </div>
        <div class="event-row">
          <span class="label">组别：</span>
          <span class="value">{{ match.group || project.matchGroupName || '-' }}</span>
        </div>
        <div class="event-row">
          <span class="label">允许性别：</span>
          <span class="value">{{ genderLimitText }}</span>
        </div>
        <div class="event-row">
          <span class="label">允许年龄：</span>
          <span class="value">{{ allowedAgeText || '-' }}</span>
        </div>
      </div>
    </div>
    <!-- 第三块：报名须知横幅（与 entry-info-team.vue 逻辑一致） -->
    <div
      v-if="!isEditMode && !playerId && (project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) && signupInstructions"
      class="signup-notice-bar"
      @click="signupInstructionsOpen = true"
    >
      <van-icon name="volume-o" class="notice-icon" />
      <span class="notice-text" :title="signupInstructionsText">{{ signupInstructionsText || '报名须知' }}</span>
      <span class="notice-link">查看详情 &gt;</span>
    </div>
    <!-- 注册球队报名类型：球员基本信息只读展示（姓名、证件类型、证件号码、性别、出生日期、报名照） -->
    <div v-if="!isEditMode && project.publicSignUp === 2 && playerId" class="player-basic-readonly">
      <div class="title">队员信息</div>
      <div class="basic-block">
        <div class="avatar-wrap">
          <div class="avatar">
            <img :src="imageView(player.avatar)" v-if="player.avatar" alt="" />
            <img src="@/assets/player-default.png" v-else alt="" />
          </div>
        </div>
        <div class="basic-info">
          <div class="name">{{ player.trueName || '-' }}</div>
          <div class="row">{{ getFormatDate(player.bmBirthday) || '-' }}</div>
          <div class="row">{{ formatGender(player.gender) }}</div>
        </div>
      </div>
    </div>
    <div class="player-form">
      <PlayerForm 
        ref="playerForm"
        :form.sync="player"
        :player-signup-fields="psfs"
        :jerseys-size-fields="project.jerseysSizeFields"
        :jerseys-size-accessory="project.jerseysSizeAccessory"
        :player-number-range="project.playerNumberRange"
        :cert-type-columns="certTypeColumns"
        :player-signup-fields-label="playerSignupFieldsLabel"
        :sport-type="project.sportType"
        :max-age="project.maxAge"
        :min-age="project.minAge"
        :qiniu-token="qiniuToken"
        :gender-limit="project.genderLimit"
        :custom-text-options="project.customTextOptions"
        :readonly-basic-info="project.publicSignUp === 2"
        :form-readonly="!!playerId && !isEditMode"
        @edit="enterEditMode"
      />
    </div>

    <!-- 第四块：底部说明（与 entry-info-team.vue 逻辑一致） -->
    <div v-if="!isEditMode && !playerId && project.signupExplanation" class="bottom-explanation">
      <div class="bottom-explanation-title">说明</div>
      <div class="bottom-explanation-content" v-html="playerSignupExplanationHtml"></div>
    </div>

    <div class="bottom" v-if="!playerId && showButton">
      <div @click="showAgreementFun" v-if="project.isUseAgreement === 1 && agreementList.length > 0"
        style="display: flex; justify-content: center; padding: 0 0 8px 0">
        <van-checkbox disabled v-model="allow" shape="square" icon-size="16px">
          <span style="font-size: 13px; color: #8C8C8C">报名前请先同意</span>
          <span v-for="item in agreementList" :key="item.id" style="color: #409EFF; font-size: 13px;">《{{ item.title
          }}》</span>
        </van-checkbox>
      </div>
      <div class="bottom-submit-wrap">
        <div class="right" @click="savePlayer" :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }">提 交</div>
      </div>
    </div>
    <!-- 有 playerId 且可编辑时：仅在编辑态显示底部“保存”按钮（查看态底部不展示任何内容） -->
    <div class="bottom bottom2 only-right" v-else-if="showButton && playerId && isEditMode">
      <div class="right" @click="updatePlayer">
        提 交
      </div>
    </div>
    <div v-else-if="team.auditStatus === 2" class="bottom bottom2">
      <div></div>
      <div class="right" @click="goEntryCertificate">查看参赛证</div>
    </div>

    <van-popup v-model="showAgreement" position="bottom" round :style="{ height: '70%' }">
      <div id="agreement"></div>
      <div style="height: 115px;"></div>
      <div class="bottom">
        <van-button type="info" block @click="allowAgreement"
          style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">同意条款</van-button>
      </div>
    </van-popup>

    <!-- 报名须知弹框（与 entry-info-team.vue 逻辑一致） -->
    <van-popup
      v-model="signupInstructionsOpen"
      :close-on-click-overlay="false"
      :style="{ width: '80%', 'border-radius': '4px' }"
    >
      <div class="notice">
        <div class="notice-title">报名须知</div>
        <div class="info" v-html="signupInstructions"></div>
        <div class="close" @click="signupInstructionsOpen = false">我知道了</div>
      </div>
    </van-popup>
    <van-dialog v-model="showDialog" title="报名提交成功" @confirm="goEntryList" confirm-button-text="我的参赛" theme="round-button"
      confirm-button-color="darkblue">
      <div style="font-size: 13px; color: #333333; padding: 12px 20px 10px 20px">
        <span style="display: inline-block; font-size: 13px; width: 2em;"></span>
        报名提交成功，您可以前往我的参赛列表查看报名进度
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getBMMatchTeamSignup,createBMMatchTeamPlayer,bangsaishiCreatePlayerSignupOrder,getBMMatchTeamPlayer,updateBMMatchTeamPlayer,cancelBMMatchTeamPlayer, checkJerseyNumberAvailability, swapJerseyNumbers } from '@/api/match'
import { getPassport } from "@/libs/passport"
import { DateUtil } from "@/utils"
import { feeMethodOptions, playerSignupFieldsLabel } from "@/config"
import PlayerForm from '@/components/PlayerForm'
import { getQiniuUploadToken } from "@/api/qiniu";
import Vue from 'vue'
import { Popup, Checkbox, CheckboxGroup, Button, Toast, Dialog, Icon } from "vant";
import { QNImageUtil } from "@/utils";
Vue.use(Popup).use(Checkbox).use(CheckboxGroup).use(Button).use(Toast).use(Dialog).use(Icon)

export default {
  components: {
    PlayerForm
  },
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      teamId: '',
      match: {},
      team: {},
      player: {},
      psfs: [],
      project: {},
      playerSignupFieldsLabel: playerSignupFieldsLabel,
      certTypeColumns: [
        { value: 1, label: '身份证' },
        { value: 11, label: '学籍卡' },
        { value: 2, label: '护照' },
        { value: 3, label: '港澳通行证' },
        { value: 4, label: '台胞证' },
        { value: 5, label: '港澳台回乡证' }
      ],
      qiniuToken: '',
      agreementList: [],
      allow: false,
      showAgreement: false,
      showDialog: false,
      playerId: '',
      orderStatus: 0,
      showButton: false,
      role: '',
      jetlympic: false,
      /** 编辑状态（有 playerId 时：false=查看显示编辑按钮，true=编辑显示保存按钮并隐藏删除） */
      isEditMode: false,
      signupInstructionsOpen: false,
      signupInstructions: ''
    };
  },
  computed: {
    /** 允许性别文案 */
    genderLimitText() {
      const g = this.match && this.match.genderLimit
      if (g === 1) return '男'
      if (g === 2) return '女'
      if (g === 3) return '不限'
      return '-'
    },
    /** 允许年龄文案 */
    allowedAgeText() {
      const m = this.match
      if (!m || m.isOpenAgeLimit !== 1) return ''
      const max = m.maxAge ? this.getFormatDate(m.maxAge) : ''
      const min = m.minAge ? this.getFormatDate(m.minAge) : ''
      if (max && min) return max + '～' + min
      if (min) return '晚于' + min
      if (max) return '早于' + max
      return ''
    },
    /** 报名须知纯文本（用于横幅一行展示，strip HTML） */
    signupInstructionsText() {
      if (!this.signupInstructions) return ''
      const div = document.createElement('div')
      div.innerHTML = this.signupInstructions
      return (div.textContent || div.innerText || '').trim()
    },
    /** 球员页底部说明 HTML：处理 \n 为换行 */
    playerSignupExplanationHtml() {
      const text = (this.project && this.project.signupExplanation) || ''
      return text ? text.replace(/\n/g, '<br/>') : ''
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.matchId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.role = this.$route.query.role
        if(this.$route.query.playerId && this.$route.query.playerId !== 'undefined'){
          this.playerId = this.$route.query.playerId
        }
        if (this.playerId && this.playerId !== 'undefined') {
          this.getBMMatchTeamPlayer()
        }
        this.getBMMatchTeamSignup()
        this.getQiniuUploadToken()
      }
    })
  },
  methods: {
    parsePlayerNumberRange() {
      const rangeStr = (this.project && this.project.playerNumberRange) || ''
      if (!rangeStr || typeof rangeStr !== 'string') return null
      const [minRaw, maxRaw] = rangeStr.split('|')
      const min = Number(minRaw)
      const max = Number(maxRaw)
      if (Number.isNaN(min) || Number.isNaN(max)) return null
      if (min === -1 && max === -1) return null
      return { min, max }
    },
    validateJerseyNumberRange(numberStr) {
      const range = this.parsePlayerNumberRange()
      if (!range) return { ok: true }
      const n = Number(numberStr)
      if (!Number.isFinite(n)) {
        return { ok: false, message: '请输入正确的球衣号码' }
      }
      if (n < range.min || n > range.max) {
        return { ok: false, message: `球衣号码需在${range.min}～${range.max}范围内` }
      }
      return { ok: true }
    },
    async checkAndMaybeSwapJerseyNumber(numberStr) {
      const res = await checkJerseyNumberAvailability({
        matchId: this.matchId,
        teamId: this.teamId,
        number: numberStr,
        playerId: this.playerId
      })
      const data = (res && res.data) || {}
      if (data.available === true) return { ok: true }
      if (data.alreadyUsed && data.occupiedByPlayerId) {
        const name = data.occupiedByPlayerName || ''
        try {
          await Dialog.confirm({
            title: '提示',
            message: `球衣号码和${name}重复，是否交换`
          })
        } catch (e) {
          return { ok: false, cancelled: true }
        }
        await swapJerseyNumbers({
          matchId: this.matchId,
          teamId: this.teamId,
          playerIdA: this.playerId,
          playerIdB: data.occupiedByPlayerId
        })
        return { ok: true, swapped: true }
      }
      const name = data.occupiedByPlayerName || ''
      Toast.fail(name ? `球衣号码已被${name}占用` : '球衣号码不可用')
      return { ok: false }
    },
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    formatGender(gender) {
      if (gender === '1' || gender === 1) return '男'
      if (gender === '2' || gender === 2) return '女'
      return '-'
    },
    enterEditMode() {
      this.isEditMode = true
    },
    goEntryCertificate() {
      this.$router.push(`/entry-page/entry-certificate/${this.matchId}?playerId=${this.playerId}`)
    },
    getBMMatchTeamPlayer() {
      const params = {
        id: this.playerId
      }
      getBMMatchTeamPlayer(params).then(res => {
        if (res) {
          const { data } = res
          console.log(data)
          const player = data.player || {}
          player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''
          player.certTypeValue = player.certType && this.certTypeColumns.find(i => i.value === player.certType)?.label || '身份证'
          if (player.certTypeValue === '身份证') {
            player.certType = 1
          }
          player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
          player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
          player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []
          if (player.qualificationFile && player.qualificationFile.length > 0) {
            const a = player.qualificationFile.split(',') || []
            player.qualificationFileList = []
            a.forEach(item => {
              player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
            })
          } else {
            player.qualificationFileList = []
          }
          if (player.insureFile && player.insureFile.length > 0) {
            const a = player.insureFile.split(',') || []
            player.insureFileList = []
            a.forEach(item => {
              player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
            })
          } else {
            player.insureFileList = []
          }
          const a = []
          
          a.reverse()
          player.domicileAreaName = a.join('/')
          this.player = player
        }
      })
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    getBMMatchTeamSignup() {
      getBMMatchTeamSignup({
        teamId: this.teamId,
        matchId: this.matchId
      }).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match
          this.team = data.team
           if (!data.team) {
            this.showButton = true
          } else if (data.team.isSubmit === 1 && data.team.auditStatus !== -1) {
            this.showButton = false
          } else if (data.team.auditStatus != 2) {
            this.showButton = data.team.auditStatus != 2
          }
          this.agreementList = data.agreement || []
          const psfs = data.match.playerSignupFields && data.match.playerSignupFields.split('|') || []
          this.psfs = psfs          
          if (data.match.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...data.match.playerSignupFieldsLabel,
            }
          }
           if (data.match.certTypeFields) {
            const certTypeFieldsArray = data.match.certTypeFields.split('|').map(Number)
            this.certTypeColumns = this.certTypeColumns.filter(item => certTypeFieldsArray.includes(item.value))
          }
          this.project = data.match
          // 报名须知：与球队报名信息页逻辑保持一致
          const p = this.project
          if (p) {
            if (p.signupInstructionsOpen === 1 || p.signupInstructionsOpen === 2) {
              this.signupInstructions = p.signupInstructions
            }
            
            // 必须阅读：除队长（role=captain）外自动弹框
            console.log(p.signupInstructionsOpen, this.role);
            
            if (p.signupInstructionsOpen === 1 && this.role !== 'captain') {
              this.signupInstructionsOpen = true
            }
          }
        }
      })
    },
     getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
     getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    allowAgreement() {
      this.allow = true
      this.showAgreement = false
    },
    showAgreementFun() {
      this.showAgreement = true
      setTimeout(() => {
        const agreement = document.getElementById('agreement')
        let inner = ''
        this.agreementList.forEach(a => {
          inner += `<div style="background-color: #fff; padding: 12px 12px 0 12px;text-align: center;font-weight: 600;font-size: 24px;margin-bottom: 4px;">${a.title}</div>`
          inner += a.content
        })
        agreement.innerHTML = inner
      }, 0)
    },
    savePlayer() {      
      this.$refs.playerForm.validate().then(() => { 
        if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
          Toast.fail('请先同意协议或条款')
          return
        }
        if (this.psfs.includes('jerseysSize') && !this.player.jerseysSize) {
          return Toast({ message: '请选择球衣尺码' })
        }
        const params = JSON.parse(JSON.stringify(this.player))
        params.id = this.teamId
        params.matchId = this.matchId
        params.saveUser = 1
        if (this.psfs.includes('number')) {
          const num = (params.number || '').toString().trim()
          const vr = this.validateJerseyNumberRange(num)
          if (!vr.ok) return Toast.fail(vr.message)
        }
        if (!params.serialNumber) params.serialNumber = '_'
        delete params.avatarList
        delete params.IDCardPhotoAList
        delete params.IDCardPhotoBList
        delete params.bmBirthdayValue
        createBMMatchTeamPlayer(params).then(res => {
          if (res) {
            if (this.project.isOpenCharge === 1 && this.project.feeMethod === 1) {
              Dialog.confirm({
                title: '报名成功',
                message: '报名成功，请前往支付费用',
              }).then(() => {
                const params = {
                  matchId: this.matchId,
                  teamId: this.teamId,
                  playerId: res.data.id
                }
                const playerId = res.data.id
                bangsaishiCreatePlayerSignupOrder(params).then(res => {
                  if (res) {
                    this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&teamId=${this.teamId}&matchId=${this.matchId}&playerId=${playerId}`)
                  }
                })
              }).catch(() => {
                this.goEntryList()
              })
            } else {
              // if (this.role === 'captain') {
              //   this.$router.back()
              //   return
              // }
              Dialog.alert({
                title: '提示',
                message: '成功加入队伍'
              }).then(() => {
                this.$router.replace({
                  path: '/entry-page/entry-info-player',
                  query: {
                    unionMatchId: this.unionMatchId,
                    teamId: this.teamId,
                    matchId: this.matchId,
                    playerId: res.data.id
                  }
                })
              })
            }
          }
        })
      })
    },
     goEntryList() {
      this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
    },
    updatePlayer() {
      this.$refs.playerForm.validate().then(async () => { 
        if (this.psfs.includes('jerseysSize') && !this.player.jerseysSize) {
          return Toast({ message: '请选择球衣尺码' })
        }
        const params = JSON.parse(JSON.stringify(this.player))
         params.id = this.playerId
        params.matchId = this.matchId
        // 球衣号码：仅在开启该字段时做范围 + 可用性校验（编辑态）
        if (this.psfs.includes('number')) {
          const num = (params.number || '').toString().trim()
          const vr = this.validateJerseyNumberRange(num)
          if (!vr.ok) return Toast.fail(vr.message)
          const checkRes = await this.checkAndMaybeSwapJerseyNumber(num)
          if (!checkRes.ok) return
        }
        delete params.avatarList
        delete params.IDCardPhotoAList
        delete params.IDCardPhotoBList
        delete params.qualificationFileList
        delete params.insureFileList
        delete params.showPlayerInfo
        delete params.domicileAreaName
        delete params.bmBirthdayValue
        delete params.certTypeValue
        updateBMMatchTeamPlayer(params).then(res => {
          if (res) {
            this.$router.go(-1)
          }
        })
      })
    },
    cancelPlayer() {
      if (this.orderStatus === 1 || this.orderStatus === 2) {
        Toast.fail('已支付报名费用，取消报名请联系组委会')
        return
      }
      Dialog.confirm({
        title: '提示',
        message: `是否确定要取消${this.player.trueName}的报名吗？`,
      }).then(() => {
        const params = {
          matchId: this.matchId,
          teamId: this.teamId,
          playerId: this.playerId
        }
        cancelBMMatchTeamPlayer(params).then(res => {
          if (res) {
            this.$router.go(-1)
            Toast('取消成功')
          }
        })
      })
      // cancelBMMatchTeamPlayer
    }
  },
};
</script>

<style scoped lang="scss">
.player-info {
  padding-bottom: 120px;
  min-height: 100vh;
  background-color: #F6F6F6;
  box-sizing: border-box;
  .player-basic-readonly {
    background: #fff;
    // padding: 16px;
    margin-bottom: 12px;
    .title {
      font-size: 15px;
      color: #1d2129;
      font-weight: 500;
      background: #F6F6F6;
      padding: 12px;
    }
    .basic-block {
      padding: 12px;
      display: flex;
      align-items: flex-start;
      .avatar-wrap {
        flex-shrink: 0;
      }
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        background: #e8e8e8;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .basic-info {
        flex: 1;
        min-width: 0;
        margin-left: 12px;
        .name {
          font-size: 16px;
          font-weight: 500;
          color: #1d2129;
          margin-bottom: 6px;
        }
        .row {
          font-size: 13px;
          color: #666;
          margin-top: 4px;
        }
      }
    }
  }
  .title-info {
    background: #FFF;
    .top-banner {
      background-color: var(--bg3);
      height: 43px;
      display: flex;
      align-items: center;
      padding-left: 24px;
      border-radius: 0 0 10px 10px;
      .team-left {
        display: flex;
        align-items: center;
      }
      .team-logo {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        overflow: hidden;
        background: #fff;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .team-text {
        color: #fff;
        .team-name {
          font-size: 15px;
          line-height: 22px;
        }
      }
    }
    .event-info {
      padding: 12px 16px 10px;
      .event-row {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #606266;
        line-height: 20px;
        & + .event-row {
          margin-top: 6px;
        }
        .label {
          flex-shrink: 0;
          color: #909399;
        }
        .value {
          flex: 1;
          min-width: 0;
        }
        .event-logo {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 6px;
        }
      }
    }
  }

  /* 报名须知横幅样式，与 entry-info-team.vue 保持一致 */
  .signup-notice-bar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #FFC60A;
    color: #000;
    font-size: 12px;
    cursor: pointer;
    .notice-icon {
      flex-shrink: 0;
      margin-right: 8px;
      font-size: 16px;
    }
    .notice-text {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .notice-link {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  /* 报名须知弹框样式：与 entry-info-team.vue 保持一致 */
  .notice {
    .notice-title {
      text-align: center;
      font-size: 16px;
      padding: 12px 0;
      // border-bottom: 1px solid #f3f3f3;
    }

    .info {
      padding: 12px;
      white-space: pre-wrap;
    }

    .close {
      text-align: center;
      color: #576B95;
      // border-top: 1px solid #f3f3f3;
      padding: 12px 0;
    }

    .disabled {
      color: #999 !important;
    }
  }
  .bottom {
    position: fixed;
    border-top: 0.5px #EEEEEE solid;
    bottom: 0;
    width: 100vw;
    padding: 14px 16px 12px 27px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
  .bottom-submit-wrap{
    display: flex;
    justify-content: flex-end;
    .right{
      width: 117px;
      height: 45px;
      border-radius: 69px;
      background: var(--bg3);
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 45px;
    }
  }
  .bottom2{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.only-right {
      justify-content: flex-end;
    }
    .left{
      font-size: 11px;
      color: #3D3D3D;
      text-align: center;
      .img{
        width: 27px;
        height: 27px;
        background: #E3F1FF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        margin-bottom: 3px;
        img{
          width: 14px;
          height: 14px;
        }
      }
    }
    .right{
      width: 117px;
      height: 45px;
      border-radius: 69px;
      background: var(--bg3);
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 45px;
    }
  }

  /* 底部说明样式，与 entry-info-team.vue 保持一致 */
  .bottom-explanation {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .bottom-explanation-title {
      font-weight: bold;
      font-size: 15px;
      color: #1d2129;
      margin-bottom: 8px;
    }
    .bottom-explanation-content {
      font-size: 14px;
      color: #606266;
      line-height: 1.6;
      &::v-deep ul {
        margin: 0;
        padding-left: 20px;
      }
      &::v-deep li {
        margin-bottom: 4px;
      }
    }
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}
</style>
